export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SET_MODEL"] = "SET_MODEL";
    ActionTypes["SET_CART"] = "SET_CART";
    ActionTypes["SET_RECIPES"] = "SET_RECIPES";
    ActionTypes["ADD_RECIPES"] = "ADD_RECIPES";
    ActionTypes["SET_PIN_NAVBUTTONS"] = "SET_PIN_NAVBUTTONS";
    ActionTypes["SET_IS_DRAFT_FLOW"] = "SET_IS_DRAFT_FLOW";
    ActionTypes["SET_RECIPE_TYPE"] = "SET_RECIPE_TYPE";
    ActionTypes["SET_REQUIREMENTS"] = "SET_REQUIREMENTS";
    ActionTypes["SET_MEALS"] = "SET_MEALS";
    ActionTypes["SET_TEMPLATE"] = "SET_TEMPLATE";
    ActionTypes["SET_OMISSIONS"] = "SET_OMISSIONS";
    ActionTypes["SET_MEAL_SIZE"] = "SET_MEAL_SIZE";
    ActionTypes["SET_DAYS_OF_WEEK"] = "SET_DAYS_OF_WEEK";
    ActionTypes["SET_SELECTED_DAY"] = "SET_SELECTED_DAY";
    ActionTypes["SET_IS_SUBSCRIPTION"] = "SET_IS_SUBSCRIPTION";
    ActionTypes["SET_START_DATE"] = "SET_START_DATE";
    ActionTypes["SET_DAY_QUANTITY"] = "SET_DAY_QUANTITY";
    ActionTypes["SET_PRODUCTS"] = "SET_PRODUCTS";
    ActionTypes["SET_CURRENT_PAGE"] = "SET_CURRENT_PAGE";
    ActionTypes["SET_TOTAL_PAGES"] = "SET_TOTAL_PAGES";
    ActionTypes["SET_DAY_FILTER_DAYS"] = "SET_DAY_FILTER_DAYS";
    ActionTypes["SET_MEAL_BUNDLE"] = "SET_MEAL_BUNDLE";
    ActionTypes["SET_SELECTED_RECIPES"] = "SET_SELECTED_RECIPES";
    ActionTypes["SET_MEAL_SELECTION_STATUS"] = "SET_MEAL_SELECTION_STATUS";
    ActionTypes["SET_RECIPE_SORT_OPTION"] = "SET_RECIPE_SORT_OPTION";
    ActionTypes["SET_PRODUCT_SORT_OPTION"] = "SET_PRODUCT_SORT_OPTION";
    ActionTypes["SET_RECIPE_FETCH_STATUS"] = "SET_RECIPE_FETCH_STATUS";
    ActionTypes["SET_SUBSCRIPTION_PERIOD"] = "SET_SUBSCRIPTION_PERIOD";
    ActionTypes["SET_QUESTION_ANSWERS"] = "SET_QUESTION_ANSWERS";
    ActionTypes["SET_POSTAL_CODE"] = "SET_POSTAL_CODE";
    ActionTypes["SET_LOCATION"] = "SET_LOCATION";
    ActionTypes["SET_PROGRAM_MEALS"] = "SET_PROGRAM_MEALS";
    ActionTypes["SET_MISC_CHARGES"] = "SET_MISC_CHARGES";
    ActionTypes["SET_WEEK_QUANTITY"] = "SET_WEEK_QUANTITY";
})(ActionTypes || (ActionTypes = {}));
